import request from '@/http/http'
const PREFIX = 'api/deer/messages';
export function getMessageInfo() {
    return request({
        url: PREFIX+"/home-page",
    })
}
export function getSystemPageList(query) {
    return request({
        url: PREFIX+"/system-page-list",
        params:query
    })
}
export function getEstatePageList(query) {
    return request({
        url: PREFIX+"/estate-page-list",
        params:query
    })
}
export function getReservationPageList(query) {
    return request({
        url: PREFIX+"/reservation-page-list",
        params:query
    })
}
export function getSystemInfo(id) {
    return request({
        url: PREFIX+`/${id}/system`,
    })
}
export function getEstateInfo(id) {
    return request({
        url: PREFIX+`/${id}/estate`,
    })
}
export function getReservationInfo(id) {
    return request({
        url: PREFIX+`/${id}/reservation`,
    })
}
export function batchUpdateReadInfo(ids) {
    return request({
        url: PREFIX+`/batch-update-read`,
        method: 'put',
        data: ids
    })
}

export function oneKeyUpdateReadInfo(query) {
    return request({
        url: PREFIX+`/one-key-update-read`,
        method: 'put',
        params: query
    })
}

export function addMessage(data) {
    return request({
      url: PREFIX+'/system',
      method: 'post',
      data
    })
  }